import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createSlots as _createSlots } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = { class: "flex h-screen flex-col bg-gray-lp-1000 gap-y-4" }
const _hoisted_2 = { class: "bg-white flex flex-col border-b border-gray-lp-400 px-8 pb-4 gap-y-4" }
const _hoisted_3 = { class: "flex flex-row h-6" }
const _hoisted_4 = { class: "flex flex-row items-center font-semibold text-20px mr-4 text-black-lp-200 title-layout" }
const _hoisted_5 = { class: "flex flex-1 gap-x-4 p-10 pt-0 overflow-hidden" }
const _hoisted_6 = { class: "w-11/20 flex flex-col overflow-hidden" }
const _hoisted_7 = { class: "bg-white rounded-2xl shadow grow overflow-y-auto px-4 py-4 flex flex-col gap-y-4" }
const _hoisted_8 = { class: "flex gap-x-2 p-2 bg-gray-lp-100 rounded-lg mt-2" }
const _hoisted_9 = { class: "w-full flex flex-col" }
const _hoisted_10 = { class: "flex items-center absolute right-0 transform top-1/2 -translate-y-1/2 px-2.5" }
const _hoisted_11 = { class: "text-blue-lp-500 text-xs" }
const _hoisted_12 = { class: "font-bold" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "px-2.5" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "h-5 bg-gray-lp-1600",
    style: {"width":"2px"}
  })
], -1)
const _hoisted_14 = { class: "underline" }
const _hoisted_15 = { class: "text-sm text-black-lp-300 font-medium font-montserrat" }
const _hoisted_16 = { class: "font-semibold flex flex-row items-center justify-between" }
const _hoisted_17 = { class: "flex flex-row items-center gap-x-1" }
const _hoisted_18 = {
  key: 0,
  class: "text-gray-lp-500 font-normal"
}
const _hoisted_19 = { class: "flex items-center gap-x-4 mt-2" }
const _hoisted_20 = { class: "text-xs text-gray-lp-600 mt-2" }
const _hoisted_21 = { class: "w-9/20 bg-white rounded-2xl py-4 flex flex-col overflow-hidden shadow" }
const _hoisted_22 = { class: "grow overflow-y-auto px-4 h-max" }
const _hoisted_23 = { class: "absolute top-3 right-3" }
const _hoisted_24 = { class: "font-semibold text-gray-lp-300 mb-2 text-base" }
const _hoisted_25 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_26 = { class: "flex flex-col gap-y-6" }
const _hoisted_27 = { class: "flex py-2.5 divide-x divide-gray-lp-1600" }
const _hoisted_28 = {
  key: 0,
  class: "flex flex-col gap-y-1 h-full px-2.5 w-1/3"
}
const _hoisted_29 = { class: "text-center text-xs text-gray-lp-800" }
const _hoisted_30 = { class: "flex items-center justify-center text-base text-black-lp-300 font-semibold" }
const _hoisted_31 = {
  class: "flex items-center justify-center break-all",
  style: 
                    `overflow: hidden; display: -webkit-box;-webkit-box-orient: vertical; -webkit-line-clamp: 2;`
                  
}
const _hoisted_32 = { style: 
                      `overflow: hidden; display: -webkit-box;-webkit-box-orient: vertical; -webkit-line-clamp: 2;`
                     }
const _hoisted_33 = /*#__PURE__*/_createVNode("p", { class: "text-center text-xs text-gray-lp-800" }, " No STT/shipment id ", -1)
const _hoisted_34 = {
  class: "text-center text-base text-black-lp-300 font-semibold break-all",
  style: 
                  `overflow: hidden; display: -webkit-box;-webkit-box-orient: vertical; -webkit-line-clamp: 2;`
                
}
const _hoisted_35 = {
  key: 1,
  class: "w-1/2 flex flex-col gap-y-1 h-full px-2.5"
}
const _hoisted_36 = { class: "text-center text-xs text-gray-lp-800" }
const _hoisted_37 = {
  class: "text-center text-base text-black-lp-300 font-semibold break-all",
  style: 
                  `overflow: hidden; display: -webkit-box;-webkit-box-orient: vertical; -webkit-line-clamp: 2;`
                
}
const _hoisted_38 = {
  key: 2,
  class: "w-1/3 flex flex-col gap-y-1 h-full px-2.5"
}
const _hoisted_39 = { class: "text-center text-xs text-gray-lp-800" }
const _hoisted_40 = {
  class: "text-center text-base text-black-lp-300 font-semibold break-words",
  style: 
                  `overflow: hidden; display: -webkit-box;-webkit-box-orient: vertical; -webkit-line-clamp: 2;`
                
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_GenericInfobar = _resolveComponent("GenericInfobar")!
  const _component_cardSTT = _resolveComponent("cardSTT")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_FilePicker = _resolveComponent("FilePicker")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_HowToReportCard = _resolveComponent("HowToReportCard")!
  const _component_Chips = _resolveComponent("Chips")!
  const _component_card = _resolveComponent("card")!
  const _component_CsInfo = _resolveComponent("CsInfo")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_Breadcrumb),
        _createVNode("div", _hoisted_3, [
          _createVNode("img", {
            src: _imports_0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onBack && _ctx.onBack(...args))),
            class: "w-5 mr-3 cursor-pointer",
            alt: "back"
          }),
          _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("pusatResolusi.create.reportIssue")), 1)
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('pusatResolusi.create.issueType')
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_8, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.typeList, (item) => {
                    return (_openBlock(), _createBlock("div", {
                      key: item.value,
                      class: ["w-1/2 py-3 text-center", {
                  'bg-white rounded-lg shadow-outer': _ctx.form.type === item.value,
                  'cursor-pointer': _ctx.form.type !== item.value
                }],
                      onClick: () => _ctx.onChangeType(item)
                    }, _toDisplayString(item.name), 11, ["onClick"]))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('pusatResolusi.columnSttShipment'),
              optional: _ctx.form.type === _ctx.getPusatResolusiV2Type.systemPenalty
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_9, [
                  _createVNode(_component_LpInput, {
                    placeholder: _ctx.$t('pusatResolusi.create.sttPlaceholder'),
                    modelValue: _ctx.form.sttNoShipmentNo,
                    "onUpdate:modelValue": [
                      _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.sttNoShipmentNo = $event)),
                      _ctx.onChangeSttNoShipmentNo
                    ],
                    customStyle: 
                  `padding-right: ${_ctx.showListDuplicate ? '300px' : '200px'};`
                ,
                    class: "mt-1",
                    error: !!_ctx.errorMessageTicket,
                    "error-caption": _ctx.errorMessageTicket,
                    isErrorIconInput: false,
                    format: _ctx.formatRefNumber
                  }, {
                    suffix: _withCtx(() => [
                      _createVNode("div", _hoisted_10, [
                        _createVNode("span", _hoisted_11, [
                          _createTextVNode(_toDisplayString(_ctx.$t("pusatResolusi.create.lastStatus")) + ": ", 1),
                          _createVNode("span", _hoisted_12, _toDisplayString(_ctx.showListDuplicate
                            ? _ctx.sttShipmentDetail[_ctx.sttShipmentDetail.length - 1]
                                .sttLastStatus
                            : _ctx.sttShipmentResponse.length
                            ? _ctx.sttShipmentResponse[
                                _ctx.sttShipmentResponse.length - 1
                              ].sttLastStatus
                            : "-"), 1)
                        ]),
                        _hoisted_13,
                        _createVNode("button", {
                          class: ["flex items-center gap-x-1 text-sm font-medium", {
                        'text-red-lp-100 cursor-pointer': _ctx.form.sttNoShipmentNo,
                        'text-gray-lp-600 cursor-not-allowed': !_ctx.form.sttNoShipmentNo
                      }],
                          onClick: _cache[2] || (_cache[2] = () => _ctx.onCheckStt(true)),
                          onMouseenter: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleTooltipCheck($event))),
                          onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleTooltipCheck($event))),
                          disabled: !_ctx.form.sttNoShipmentNo
                        }, [
                          _createVNode(_component_Icons, {
                            name: "refresh",
                            class: "w-4"
                          }),
                          _createVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("pusatResolusi.create.check")), 1)
                        ], 42, ["disabled"]),
                        _createVNode(_component_OverlayPanel, { ref: "opTooltip" }, {
                          default: _withCtx(() => [
                            _createVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("pusatResolusi.create.reload")), 1)
                          ]),
                          _: 1
                        }, 512)
                      ])
                    ]),
                    _: 1
                  }, 8, ["placeholder", "modelValue", "onUpdate:modelValue", "customStyle", "error", "error-caption", "format"]),
                  (_ctx.showListDuplicate)
                    ? (_openBlock(), _createBlock(_component_GenericInfobar, {
                        key: 0,
                        class: "mt-2",
                        items: _ctx.actionItems,
                        onItemClick: _ctx.toDetail,
                        disabled: _ctx.prohibitedDuplicate
                      }, null, 8, ["items", "onItemClick", "disabled"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["label", "optional"]),
            (!_ctx.sttOrShipmentNoInLastSttOrShipmentList)
              ? (_openBlock(), _createBlock(_component_cardSTT, {
                  key: 0,
                  onSelect: _ctx.onSelectStt
                }, null, 8, ["onSelect"]))
              : _createCommentVNode("", true),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('pusatResolusi.create.category')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CustomDropdown, {
                  modelValue: _ctx.form.category,
                  "onUpdate:modelValue": [
                    _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.category = $event)),
                    _ctx.onSelectCategory
                  ],
                  "onUpdate:isExpand": _ctx.getListCategory,
                  preventUnselect: "",
                  "selected-item": _ctx.form.category,
                  options: _ctx.listCategory,
                  placeholder: _ctx.$t('pusatResolusi.create.selectCategory'),
                  class: "mt-2",
                  isDisabled: _ctx.prohibitedDuplicate,
                  disableBackground: _ctx.prohibitedDuplicate,
                  error: !!_ctx.sttIssueCategory,
                  "error-caption": _ctx.sttIssueCategory,
                  customChips: "rounded-full px-1 text-white self-start"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onUpdate:isExpand", "selected-item", "options", "placeholder", "isDisabled", "disableBackground", "error", "error-caption"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, null, {
              label: _withCtx(() => [
                _createVNode("div", _hoisted_16, [
                  _createVNode("div", _hoisted_17, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t("pusatResolusi.create.description")), 1),
                    (!_ctx.form.isDescRequired)
                      ? (_openBlock(), _createBlock("span", _hoisted_18, " (" + _toDisplayString(_ctx.$t("optional")) + ") ", 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("button", {
                    class: ["text-xs", {
                    'text-red-lp-100 cursor-pointer': _ctx.form.description,
                    'text-gray-lp-600 cursor-not-allowed': !_ctx.form.description
                  }],
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onDeleteDescription && _ctx.onDeleteDescription(...args))),
                    disabled: !_ctx.form.description
                  }, _toDisplayString(_ctx.$t("pusatResolusi.create.deleteDescription")), 11, ["disabled"])
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  placeholder: _ctx.$t('pusatResolusi.create.descPlaceholder'),
                  modelValue: _ctx.form.description,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.description = $event)),
                  onFocus: _ctx.onCheckStt,
                  class: "mt-1",
                  type: "textarea",
                  maxLength: "500",
                  showMaxLength: "",
                  disableBackground: _ctx.prohibitedDuplicate,
                  disabled: _ctx.prohibitedDuplicate
                }, null, 8, ["placeholder", "modelValue", "onFocus", "disableBackground", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('attachment'),
              optional: !_ctx.form.isAttachmentRequired
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_19, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.form.attachments, (_, index) => {
                    return (_openBlock(), _createBlock("div", { key: index }, [
                      _createVNode(_component_FilePicker, {
                        ref: `attachment-${index}`,
                        title: `${_ctx.$t('attach')} ${index + 1}`,
                        modelValue: _ctx.form.attachments[index],
                        "onUpdate:modelValue": [($event: any) => (_ctx.form.attachments[index] = $event), _ctx.onCheckStt],
                        accept: _ctx.acceptContentFlag,
                        disabled: _ctx.prohibitedDuplicate,
                        showDeleteIcon: index > 0,
                        onDelete: () => _ctx.onDeleteAttachment(index)
                      }, null, 8, ["title", "modelValue", "onUpdate:modelValue", "accept", "disabled", "showDeleteIcon", "onDelete"])
                    ]))
                  }), 128)),
                  (_ctx.form.attachments.length < 3)
                    ? (_openBlock(), _createBlock(_component_LpButton, {
                        key: 0,
                        textColor: "white",
                        iconGroupHoverColor: "white",
                        iconV2: "",
                        iconLeft: "plus-icon",
                        rounded: "",
                        compact: "",
                        onClick: _ctx.onAddFile,
                        disabled: _ctx.prohibitedDuplicate,
                        sizeIcon: "w-5"
                      }, null, 8, ["onClick", "disabled"]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("p", _hoisted_20, _toDisplayString(_ctx.$t('pusatResolusi.create.uploadDesc')), 1)
              ]),
              _: 1
            }, 8, ["label", "optional"]),
            _createVNode(_component_LpButton, {
              title: _ctx.$t('pusatResolusi.create.submit'),
              textColor: "white",
              iconV2: "",
              iconLeft: "save",
              iconV2Fill: "",
              iconGroupHoverColor: "text-white",
              isWidthFull: "",
              onClick: _ctx.onConfirmCreate,
              disabled: _ctx.disabled
            }, null, 8, ["title", "onClick", "disabled"])
          ])
        ]),
        _createVNode("div", _hoisted_21, [
          _createVNode("div", _hoisted_22, [
            _createVNode(_component_HowToReportCard)
          ])
        ])
      ])
    ]),
    (_ctx.showResponseCreate)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          title: _ctx.responseCreateData.title,
          message: _ctx.responseCreateData.message,
          image: _ctx.responseCreateData.image,
          textSuccess: _ctx.responseCreateData.textSuccess,
          onSubmit: _ctx.responseCreateData.onSubmit,
          textCancel: _ctx.responseCreateData.textCancel,
          onClose: _ctx.responseCreateData.onClose,
          customWidth: "708px",
          customWrapperButton: "w-full",
          isButtonFull: ""
        }, _createSlots({
          default: _withCtx(() => [
            _createVNode("div", _hoisted_23, [
              _createVNode(_component_Icons, {
                name: "close",
                class: "w-5 text-gray-lp-600 cursor-pointer",
                onClick: _ctx.responseCreateData.onClose
              }, null, 8, ["onClick"])
            ])
          ]),
          custom: _withCtx(() => [
            _createVNode("div", _hoisted_26, [
              _createVNode(_component_card, {
                isShadow: false,
                class: "mt-3"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_27, [
                    (
                _ctx.ticketDetail.code !== _ctx.pusatResolusiV2CodeResponseCreate['103']
              )
                      ? (_openBlock(), _createBlock("div", _hoisted_28, [
                          _createVNode("p", _hoisted_29, _toDisplayString(_ctx.$t('pusatResolusi.create.noKendala')), 1),
                          _createVNode("p", _hoisted_30, [
                            _createVNode("span", _hoisted_31, _toDisplayString(_ctx.ticketDetail.caseNumber || "-"), 1),
                            (_ctx.ticketDetail.statusData?.label && !_ctx.ticketDetail.success)
                              ? (_openBlock(), _createBlock(_component_Chips, {
                                  key: 0,
                                  rounded: "",
                                  textColor: _ctx.ticketDetail.statusData?.text,
                                  color: _ctx.ticketDetail.statusData?.background,
                                  weight: "medium",
                                  class: "ml-1"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode("span", _hoisted_32, _toDisplayString(_ctx.ticketDetail.statusData?.label), 1)
                                  ]),
                                  _: 1
                                }, 8, ["textColor", "color"]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("div", {
                      class: ["flex flex-col gap-y-1 h-full px-2.5", 
                _ctx.ticketDetail.code !== _ctx.pusatResolusiV2CodeResponseCreate['103']
                  ? 'w-1/3'
                  : 'w-1/2'
              ]
                    }, [
                      _hoisted_33,
                      _createVNode("p", _hoisted_34, _toDisplayString(_ctx.ticketDetail.refNo || _ctx.ticketDetail.sttNo || "-"), 1)
                    ], 2),
                    (
                _ctx.ticketDetail.code === _ctx.pusatResolusiV2CodeResponseCreate['103']
              )
                      ? (_openBlock(), _createBlock("div", _hoisted_35, [
                          _createVNode("p", _hoisted_36, _toDisplayString(_ctx.$t('Status Terakhir')), 1),
                          _createVNode("p", _hoisted_37, _toDisplayString(_ctx.ticketDetail.sttLastStatus), 1)
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_38, [
                          _createVNode("p", _hoisted_39, _toDisplayString(_ctx.$t('pusatResolusi.create.kategoriKendala')), 1),
                          _createVNode("p", _hoisted_40, _toDisplayString(_ctx.$t(_ctx.ticketDetail.categoryName)), 1)
                        ]))
                  ])
                ]),
                _: 1
              }),
              (_ctx.showCsInfoCreateResponse)
                ? (_openBlock(), _createBlock(_component_CsInfo, {
                    key: 0,
                    isClaim: _ctx.ticketDetail.action === _ctx.getPusatResolusiV2Action.CLAIM,
                    csInfoPopup: "",
                    sttNo: _ctx.ticketDetail.refNo
                  }, null, 8, ["isClaim", "sttNo"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 2
        }, [
          (_ctx.ticketDetail.action === _ctx.getPusatResolusiV2Action.CS)
            ? {
                name: "title",
                fn: _withCtx(() => [
                  _createVNode("p", _hoisted_24, [
                    _createTextVNode(_toDisplayString(_ctx.$t('pusatResolusi.create.problemDescTop')) + " ", 1),
                    _hoisted_25,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('pusatResolusi.create.problemDescBot')), 1)
                  ])
                ])
              }
            : undefined
        ]), 1032, ["title", "message", "image", "textSuccess", "onSubmit", "textCancel", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}